import * as React from "react";
import { useState } from "react";
import { Button, ButtonToolbar, DeleteMenuItem, MenuItem } from "components/bootstrap";
import { LinkContainer } from "components/common";
import MoreActions from "components/common/EntityDataTable/MoreActions";
import AIManagementRoutes from "ai-management/Routes";
import useDeleteModelProvider from "ai-management/model-providers/hooks/useDeleteModelProvider";
import useSetDefaultModelProvider from "ai-management/model-providers/hooks/useSetDefaultModelProvider";
import DeleteModelProviderDialog from "ai-management/model-providers/delete/DeleteModelProviderDialog";
const ModelProviderActions = ({ provider }) => {
  const { setDefault } = useSetDefaultModelProvider();
  const { deleteProvider, isDeleting } = useDeleteModelProvider();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const onSetDefault = () => {
    setDefault(provider.id).catch(() => {
    });
  };
  const onDelete = () => deleteProvider(provider.id).then(() => setShowDeleteDialog(false)).catch(() => {
  });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ButtonToolbar, null, provider.enabled ? /* @__PURE__ */ React.createElement(LinkContainer, { to: AIManagementRoutes.modelProviderEdit(provider.id) }, /* @__PURE__ */ React.createElement(Button, { bsSize: "xs" }, "Edit")) : /* @__PURE__ */ React.createElement(Button, { bsSize: "xs", disabled: true }, "Edit"), /* @__PURE__ */ React.createElement(MoreActions, null, /* @__PURE__ */ React.createElement(MenuItem, { disabled: provider.is_default || !provider.enabled, onSelect: onSetDefault }, "Set as default"), /* @__PURE__ */ React.createElement(MenuItem, { divider: true }), /* @__PURE__ */ React.createElement(DeleteMenuItem, { onSelect: () => setShowDeleteDialog(true) }))), showDeleteDialog && /* @__PURE__ */ React.createElement(
    DeleteModelProviderDialog,
    {
      provider,
      isDeleting,
      onConfirm: onDelete,
      onCancel: () => setShowDeleteDialog(false)
    }
  ));
};
export default ModelProviderActions;
